import type { ImportVisitorsWorkerRequest, ImportVisitorsWorkerResponse } from './types';

export const importVisitorsFromXlsx = async (
  file: File,
  allowInviteToParking: boolean,
  maxVisitors: number,
) => {
  const fileBuffer = await file.arrayBuffer();

  return new Promise<ImportVisitorsWorkerResponse>(resolve => {
    const worker = new Worker(new URL('./import-visitors.worker.ts', import.meta.url), {
      type: 'module',
    });

    const cleanup = () => {
      worker.onmessage = null;
      worker.onerror = null;
      worker.terminate();
    };

    worker.onmessage = ({ data }: MessageEvent<ImportVisitorsWorkerResponse>) => {
      cleanup();
      resolve(data);
    };

    worker.onerror = () => {
      cleanup();
      resolve({
        success: false,
        errorCode: 'invalid_file',
      });
    };

    const workerPayload: ImportVisitorsWorkerRequest = {
      fileBuffer,
      allowInviteToParking,
      maxVisitors,
    };

    worker.postMessage(workerPayload, [fileBuffer]);
  });
};
